import { Component, Input,OnInit,HostListener,ViewChild,ElementRef } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { gatekeyService } from '../../service/gatekey.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { Http, ResponseContentType } from '@angular/http';
import { commonService } from '../../service/common.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-examsolution',
  templateUrl: './examsolution.component.html',
  styleUrls: ['./examsolution.component.css'],
  providers:[gatekeyService]
})
export class ExamsolutionComponent implements OnInit {

  modalReference:NgbModalRef;
  topicbox:any;
  doc:any;
  tagposttopic:any;
  msg:any;
  isError=false;
  isSuccess=false;
  formvailidation=false;
  topic:any;
  docId:any;
  contentTitle:any;
  contentlist=[];
  topiclist:any;
  isPostLoad=true;
  isRemaningForum=true;
  noMoreResults=false;
  obj={};
  
  searchtxt:any;
  userData:any;
  isclickbutton=false;

  userid:any;

  Examsolution={'title':'Student Portal - GATE and ESE 2019 Exam Solutions','desciprtion':'Find all GATE and ESE 2019 Exam related details and solutions for EC, CE, ME, EE, GS, General Studies. IES 2019 Notification, Answer keys, ESE Preparation','keywords':'IES 2019 Notification, GATE 2019, ESE Exam, Exam Solutions, GATE Exam Details, Answer keys, ESE Preparation, Detailed Solutions, EC, CE, ME, EE, GS, General Studies'};
 



  constructor(private _gatekey:gatekeyService,public el: ElementRef,private http:Http,private modalService: NgbModal,private router:Router,private global:Globals,private _common:commonService,private permissionsService: NgxPermissionsService)  {

    this._common.profile.subscribe((data:any)=>{
      if(typeof data=='object' &&  data!=null){
        this.userData = data;
         this.userid = data.id;
         //this.contentlist=[];
        // this.isPostLoad=true;
         //this.getgatekey();
      }else{
        this.userData={};
        
      } 
      })
   }


   readonly rootUrl = this.global.siteUrl;
   readonly filepathUrl  =  this.global.gatekeyUrl;


   @HostListener('window:scroll', ['$event'])
   checkScroll() {
      var scrollPosition = $(window).scrollTop() + $(window).height();
      //var pageheight =  $(document).height()-$('#footer-section').outerHeight();
      var pageheight =  $(document).height()-100;
      if(scrollPosition >= pageheight && this.isRemaningForum==true && this.contentlist.length>0) {
        this.isPostLoad=true;
        this.getgatekey();
      }
   }

  ngOnInit() {
    //this.obj['limit']=20;
    this.getgatekey();
  }

  datediff(date){
    return this._common.datediff(date);

   }
   filterform(searchtxt){
    var txt = searchtxt.value.search.trim();
    if(txt!=""){
    this.router.navigateByUrl('/examsolution?search='+txt);
    }else{
      this.router.navigateByUrl('/examsolution');
    }
    this.searchtxt=txt;
    this.contentlist=[];
    this.noMoreResults = false;
    this.getgatekey(); 
  }

   loginreq(id) {
    let encodeUrl:any;
    if(Object.keys(this.userData).length == 0){
      this.needLogin();
      return false;
    } 
    if(id){
      encodeUrl="cid="+id+"&userid="+this.userid;
       encodeUrl=encodeURIComponent(encodeUrl);
       //window.open(this.global.websiteUrl+'jobdetail?searchparam='+btoa(encodeUrl)); 
      this.router.navigateByUrl('/challenge?searchparam='+btoa(encodeUrl));
  
    }else{
      this.router.navigateByUrl('/job');
    }

   }

   needLogin(){
 
    this._common.setLoginBox(true);        
  }

   public downloadFile(filename) {

    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 

    return this.http.get(this.filepathUrl+filename,{
      responseType: ResponseContentType.Blob,
    }).map(res => {
      return {
        filename: filename,
        data: res.blob()
      };
    }).subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        //console.log('download error:', JSON.stringify(error));
             if(error.status="404"){
                    alert('Something went wrong. Please try to latter.');
             }
      }, () => {
       // console.log('Completed file download.')
      });
}

  getgatekey(){
    this.obj['limit']=20;
    this.obj['offset']= this.contentlist.length?this.contentlist.length:0;
    this.obj['search'] = this.searchtxt?this.searchtxt:'';
    this.obj['userid']=this.userData?this.userData.id:'';
    this._gatekey.getgatekey(this.obj).subscribe((data : any)=>{     
      if(data.error==0){ 
       // console.log('RRRRRRRRRRRRRRRRRRRR');
       // console.log(data.results.rows);
        if(data.results.rows.length > 0){    
          this.isPostLoad=false;
          Array.prototype.push.apply(this.contentlist,data.results.rows);
         // console.log(this.contentlist);
        }else{
          this.isRemaningForum=false;
          this.isPostLoad=false;
          this.noMoreResults = true;
        }
    }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    }); 


  }
  autoload(val){
 
    // console.log(this.topicbox);
     //var filtered = this.topicbox.filter(a=>a.display.toString().toLowerCase()===event.toString().toLowerCase());
   
     
   if(val!=""){
     var filtered = this.topicbox.filter((item) => {
       return (item.display.charAt(0).toLowerCase().indexOf(val.toLowerCase()) >= -1 ||
       item.display.toLowerCase().indexOf(val.toLowerCase()) >= -1 );
   })
   //console.log(filtered);
   }
   }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/examsolution/examsolution.component.ts